/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApplicationResponsiblePersonRequest } from './ApplicationResponsiblePersonRequest';
import {
    ApplicationResponsiblePersonRequestFromJSON,
    ApplicationResponsiblePersonRequestFromJSONTyped,
    ApplicationResponsiblePersonRequestToJSON,
    ApplicationResponsiblePersonRequestToJSONTyped,
} from './ApplicationResponsiblePersonRequest';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { ApplicationStatus } from './ApplicationStatus';
import {
    ApplicationStatusFromJSON,
    ApplicationStatusFromJSONTyped,
    ApplicationStatusToJSON,
    ApplicationStatusToJSONTyped,
} from './ApplicationStatus';
import type { ApplicationMigrationStatus } from './ApplicationMigrationStatus';
import {
    ApplicationMigrationStatusFromJSON,
    ApplicationMigrationStatusFromJSONTyped,
    ApplicationMigrationStatusToJSON,
    ApplicationMigrationStatusToJSONTyped,
} from './ApplicationMigrationStatus';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface ApplicationCreateRequest
 */
export interface ApplicationCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateRequest
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateRequest
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateRequest
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateRequest
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApplicationCreateRequest
     */
    logoutUri?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    canIssueIdTokens?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    canIssueAccessTokens?: boolean;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof ApplicationCreateRequest
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    isSearchableInMinSide?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {UserType}
     * @memberof ApplicationCreateRequest
     */
    userType?: UserType;
    /**
     * 
     * @type {ApplicationStatus}
     * @memberof ApplicationCreateRequest
     */
    status?: ApplicationStatus;
    /**
     * 
     * @type {ApplicationMigrationStatus}
     * @memberof ApplicationCreateRequest
     */
    migrationStatus?: ApplicationMigrationStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    isIdPortenFederationDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    isStafFederationDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    requiresElevatedSecurityPolicy?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationCreateRequest
     */
    canAppResponsiblesAppointExternalApprovers?: boolean;
    /**
     * 
     * @type {Array<ApplicationResponsiblePersonRequest>}
     * @memberof ApplicationCreateRequest
     */
    responsiblePersons?: Array<ApplicationResponsiblePersonRequest> | null;
}



/**
 * Check if a given object implements the ApplicationCreateRequest interface.
 */
export function instanceOfApplicationCreateRequest(value: object): value is ApplicationCreateRequest {
    return true;
}

export function ApplicationCreateRequestFromJSON(json: any): ApplicationCreateRequest {
    return ApplicationCreateRequestFromJSONTyped(json, false);
}

export function ApplicationCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'url': json['url'] === undefined ? undefined : json['url'] === null ? null : json['url'],
        'logoutUri': json['logoutUri'] === undefined ? undefined : json['logoutUri'] === null ? null : json['logoutUri'],
        'canIssueIdTokens': json['canIssueIdTokens'] == null ? undefined : json['canIssueIdTokens'],
        'canIssueAccessTokens': json['canIssueAccessTokens'] == null ? undefined : json['canIssueAccessTokens'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'isSearchableInMinSide': json['isSearchableInMinSide'] == null ? undefined : json['isSearchableInMinSide'],
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'status': json['status'] == null ? undefined : ApplicationStatusFromJSON(json['status']),
        'migrationStatus': json['migrationStatus'] == null ? undefined : ApplicationMigrationStatusFromJSON(json['migrationStatus']),
        'isIdPortenFederationDisabled': json['isIdPortenFederationDisabled'] == null ? undefined : json['isIdPortenFederationDisabled'],
        'isStafFederationDisabled': json['isStafFederationDisabled'] == null ? undefined : json['isStafFederationDisabled'],
        'requiresElevatedSecurityPolicy': json['requiresElevatedSecurityPolicy'] == null ? undefined : json['requiresElevatedSecurityPolicy'],
        'canAppResponsiblesAppointExternalApprovers': json['canAppResponsiblesAppointExternalApprovers'] == null ? undefined : json['canAppResponsiblesAppointExternalApprovers'],
        'responsiblePersons': json['responsiblePersons'] === undefined ? undefined : json['responsiblePersons'] === null ? null : ((json['responsiblePersons'] as Array<any>).map(ApplicationResponsiblePersonRequestFromJSON)),
    };
}

export function ApplicationCreateRequestToJSON(json: any): ApplicationCreateRequest {
    return ApplicationCreateRequestToJSONTyped(json, false);
}

export function ApplicationCreateRequestToJSONTyped(value?: ApplicationCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shortName': value['shortName'],
        'name': value['name'],
        'description': value['description'],
        'url': value['url'],
        'logoutUri': value['logoutUri'],
        'canIssueIdTokens': value['canIssueIdTokens'],
        'canIssueAccessTokens': value['canIssueAccessTokens'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'isSearchableInMinSide': value['isSearchableInMinSide'],
        'requiresMfa': value['requiresMfa'],
        'userType': UserTypeToJSON(value['userType']),
        'status': ApplicationStatusToJSON(value['status']),
        'migrationStatus': ApplicationMigrationStatusToJSON(value['migrationStatus']),
        'isIdPortenFederationDisabled': value['isIdPortenFederationDisabled'],
        'isStafFederationDisabled': value['isStafFederationDisabled'],
        'requiresElevatedSecurityPolicy': value['requiresElevatedSecurityPolicy'],
        'canAppResponsiblesAppointExternalApprovers': value['canAppResponsiblesAppointExternalApprovers'],
        'responsiblePersons': value['responsiblePersons'] == null ? undefined : ((value['responsiblePersons'] as Array<any>).map(ApplicationResponsiblePersonRequestToJSON)),
    };
}

